import { defineQuery, useQuery, useQueryCache } from "@pinia/colada";

const accountParsed = v.safeParse(accountSchema, account);

export const useAccount = defineQuery(() => {
  const { data: account, isLoading, status } = useQuery<Account, Error, Account>({
    key: () => ["account"],
    query: async () => v.parse(accountSchema, await ajaxRequest<Account | null>("get_account")),
    initialData: () => accountParsed.success ? accountParsed.output : null,
    enabled: !accountParsed.success,
    placeholderData: null,
  });
  const isLoggedIn = computed(() => !!account.value);
  return { account, isLoading, status, isLoggedIn };
});

export function useUpdateAccountForm() {
  const queryCache = useQueryCache();
  const { account } = useAccount();
  return useFormHandler<{ message: string; account: Account }, UpdateAccount>({
    schema: updateAccountSchema,
    action: "update_account",
    initialValues: computed(() => account.value ? v.parse(updateAccountSchema, account.value) : undefined),
    onSuccess: ({ account }) => {
      queryCache.setQueryData(["account"], v.parse(accountSchema, account));
    },
  });
}
